import {
  ActivationRequiredWarning,
  CopyButton,
  InfoIcon,
  SwitchAppButton,
} from "../../components";
import { GrayBackground } from "../../components";
import { LRSection } from "../../components/SectionedHorizontalLinedTable/GrayBackground/LRSection";
import { HookFormSelect, SubmitButton, TextInput } from "../../hook-form";
import { countries } from "../../constants";
import { Badge } from "../../components";
import {
  IAccountDetailsSettings,
  IHookForm,
  StatusColors,
} from "../../interfaces-and-types";
import { Link } from "react-router-dom";
import { timezones } from "../../utils";
// import { DevTool } from "@hookform/devtools";

export const View = ({
  merchantId,
  accountStatusBadgeInfo: account_statusBadgeInfo,
  isVerifiedMerchant,
  isNigerianMerchant,
  isBvnProvided,
  isNinProvided,
  isVerificationRequested,
  deactivateAccount,
  goBack,
  isDirty,
  merchantHandleAlreadyExists,
  handleSubmit,
  control,
  errors,
  register,
}: IHookForm<IAccountDetailsSettings> & {
  merchantId: string;
  isVerifiedMerchant: boolean;
  isNigerianMerchant: boolean;
  isBvnProvided: boolean;
  isNinProvided: boolean;
  isVerificationRequested: boolean;
  accountStatusBadgeInfo: { text: string; statusColor: StatusColors };
  deactivateAccount: () => void;
  goBack: () => void;
  isDirty: boolean;
  merchantHandleAlreadyExists: boolean;
}) => {
  const merchantHandleAdvisory = (
    <>
      <strong className="text-danger flex-container justify-content--center pt-5">
        NOTE: You can only set your handle once!
      </strong>
      <hr />
      The merchant handle is used for quick identification for transfers between
      merchant accounts on SwitchApp or for inter-merchant transfers across
      gateways.
      <br />
      <span className="text-success">
        So make sure it is a value you would like to preserve permanently.
      </span>
      <br />
      <br />
      Only lower case alphanumeric characters (i.e. a-z and 0-9) are allowed
      with <span className="text-danger">NO</span> spaces e.g. merchant001.
    </>
  );

  return (
    <>
      <form onSubmit={handleSubmit}>
        <ActivationRequiredWarning
          title="Please you need to activate your profile"
          subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up"
          urlTarget="/onboarding"
        />
        <GrayBackground>
          <div className="flex-container col justify-content-between ">
            <div className="flex-container col row-container-account-details">
              <LRSection
                leftText={<strong>Merchant ID</strong>}
                rightText={
                  <div className="flex-container justify-content--start align-items--center no-wrap">
                    <div className="transaction-id-text modal-header--title">
                      <span
                        title={merchantId}
                        className="text-primary font-ctm--bold"
                      >
                        {merchantId}
                      </span>
                    </div>
                    <div className="copy-button--container ml-3">
                      <CopyButton
                        name="copy-beneficiary-id-button"
                        stringToCopy={merchantId}
                        iconDescription="copy beneficiary id"
                        className="copy-btn"
                      />
                    </div>
                  </div>
                }
              />
              <LRSection
                leftText={<strong>Account name</strong>}
                rightText={
                  <TextInput
                    name="merchant_name"
                    label=""
                    type="text"
                    containerClassName="settings-input"
                    disabled={isVerifiedMerchant}
                    register={register}
                    errors={errors}
                  />
                }
              />
              {!isNigerianMerchant ? null : (
                <>
                  <LRSection
                    leftText={<strong>BVN</strong>}
                    rightText={
                      <TextInput
                        name="bvn"
                        label=""
                        type="text"
                        containerClassName="settings-input"
                        title={
                          isBvnProvided
                            ? "A value has already been provided. Please contact SwitchApp support if you wish to update it"
                            : ""
                        }
                        disabled={isBvnProvided}
                        register={register}
                        errors={errors}
                      />
                    }
                  />
                  <LRSection
                    leftText={<strong>NIN</strong>}
                    rightText={
                      <TextInput
                        name="nin"
                        label=""
                        type="text"
                        containerClassName="settings-input"
                        title={
                          isNinProvided
                            ? "A value has already been provided. Please contact SwitchApp support if you wish to update it"
                            : ""
                        }
                        disabled={isNinProvided}
                        register={register}
                        errors={errors}
                      />
                    }
                  />
                </>
              )}
              <LRSection
                className="align-items--start"
                leftText={<strong>SwitchApp Transfer Handle (@)</strong>}
                rightText={
                  <div className="flex-container col">
                    <div className="flex-container">
                      <TextInput
                        name="merchant_handle"
                        title={
                          merchantHandleAlreadyExists
                            ? "A merchant handle already exists. You cannot change your handle after setting it. Please contact SwitchApp support"
                            : "Only lower case alphanumeric characters are allowed (i.e. a-z and 0-9)"
                        }
                        label=""
                        placeholder="uniquemerchanthandle"
                        type="text"
                        containerClassName="settings-input flex-box"
                        inputPattern="[a-z0-9]+"
                        disabled={merchantHandleAlreadyExists}
                        register={register}
                        errors={errors}
                      />
                      <InfoIcon message={merchantHandleAdvisory} />
                    </div>

                    {merchantHandleAlreadyExists ? null : (
                      <div className="mt-5 align-items--start">
                        <Badge
                          statusColor="warning"
                          text={merchantHandleAdvisory}
                          title="The merchant handle is used for transfers between
                      merchant accounts on SwitchApp or for inter-merchant
                      transfers across gateways."
                          className=""
                          hideIndicator
                        />
                      </div>
                    )}
                  </div>
                }
              />
              <LRSection
                leftText={<strong>Country</strong>}
                rightText={
                  <HookFormSelect
                    name="country"
                    label=""
                    containerClassName="settings-select"
                    selectItems={[]}
                    selectGroupedItems={countries}
                    register={register}
                    errors={errors}
                  />
                }
              />

              <LRSection
                leftText={
                  <strong>
                    <label htmlFor="registration_number">Time zone</label>
                  </strong>
                }
                rightText={
                  <HookFormSelect
                    name="time_zone"
                    label=""
                    containerClassName="settings-select"
                    selectItems={Object.keys(timezones).map((zone) => ({
                      text: zone,
                      value: zone,
                    }))}
                    register={register}
                    errors={errors}
                  />
                }
              />

              <LRSection
                leftText={<strong>Account Activation</strong>}
                rightText={
                  <div className="flex-container row justify-content--between align-items--center">
                    <Badge
                      statusColor={account_statusBadgeInfo.statusColor}
                      text={account_statusBadgeInfo.text}
                      className="mr-5 mb-5"
                    />
                    {isVerificationRequested ? null : (
                      <p className="">
                        Click{" "}
                        <Link
                          to="/onboarding"
                          className="switchapp-link font-ctm--bold"
                        >
                          here
                        </Link>{" "}
                        to request account activation now
                      </p>
                    )}
                  </div>
                }
              />
            </div>
            <div className="flex-container row-container-account-details-right size-100 justify-content--end align-items--end">
              <div className="button-group">
                <SwitchAppButton size="sm" kind="secondary" onClick={goBack}>
                  Cancel
                </SwitchAppButton>

                <SubmitButton
                  size="sm"
                  // disabled={!isDirty}
                  showChildrenWithLoadingIcon
                >
                  Save
                </SubmitButton>
              </div>
            </div>
          </div>
        </GrayBackground>

        <div className="flex-container flex-break--small row deactivate-info-container">
          <div className="flex-container col flex-box">
            <strong>Deactivate Account</strong>
            <span className="verify-text text-danger mt-5 mb-5">
              Deactivating your SwitchApp account means you will be unable to
              receive or recover any of your payment history or account
              information.
            </span>
          </div>
          <SwitchAppButton size="sm" kind="danger" onClick={deactivateAccount}>
            Deactivate Account
          </SwitchAppButton>
        </div>
      </form>

      {/* setup hook form dev tool */}
      {/* <DevTool control={control} />  */}
    </>
  );
};
